<template>
    <div>
        <custom-contract-send-confirmation
            v-if="showConfirmation"
            :state="state"
            v-on:close="showConfirmation = false"
            v-on:success="sendFor('signing')"
            :custom-contract="value"
        />

        <div class="tab-top">
            <h2>{{$t('digital.tabs.review.headline')}}</h2>
            <p>{{$t('digital.tabs.review.label')}}</p>
        </div>

        <div class="seperator"></div>

        <div class="wizard-component review">
            <div v-if="value.property" class="box">
                <p class="subject">{{$t('digital.tabs.review.property')}}</p>
                <div class="info">
                    <div class="icon">
                        <SvgIcon icon="house"/>
                    </div>
                    <p> {{ value.property.address }}</p>
                </div>
            </div>

            <div class="box" v-if="value.tenants.length > 0 || value.landlord_email">
                <div v-for="tenant in value.tenants">
                    <p class="subject">{{$t('digital.tabs.tenant.tabname')}}</p>
                    <div class="info">
                        <div class="icon">
                            <SvgIcon icon="avatar"/>
                        </div>
                        <p v-if="tenant.full_name"> {{ tenant.full_name }}</p>
                        <p v-else>{{ tenant.email }}</p>
                    </div>
                </div>

                <div v-if="value.landlord_email">
                    <p class="subject">{{$t('digital.tabs.landlord.headline')}}</p>
                    <div class="info">
                        <div class="icon">
                            <SvgIcon icon="avatar"/>
                        </div>
                        <p v-if="value.landlord"> {{ value.landlord.name }} </p>
                        <p v-else>{{ value.landlord_email }}</p>
                    </div>
                </div>
            </div>

            <div v-if="value.is_created_by_broker === true && value.requires_landlord_approval === true"
                 class="box preview-box">
                <div class="flex-display">
                    <p class="subject">{{$t('digital.tabs.review.approval-status')}}</p>
                    <div class="box-revoke">
                        <div
                            v-if="value.is_landlord_approval_requested === true || value.is_approved_by_landlord === true">
                            <button class="purple" @click="revoke()" :disabled="state === 'saving'">
                                <span>{{$t('digital.behalfoflandlord.revokeapproval')}}</span>
                            </button>
                        </div>
                        <div v-else>
                            <button class="purple" @click="sendFor('approval')" :disabled="state === 'saving'">
                                <span v-if="value.is_landlord_approval_requested === true">{{$t('digital.behalfoflandlord.resend')}}</span>
                                <span v-if="value.is_landlord_approval_requested === false">{{$t('digital.behalfoflandlord.sendforapproval')}}</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="status-box" v-if="value.requires_landlord_approval === true">
                    <strong>Approval of contract</strong>
                    <div v-if="value.is_landlord_approval_requested === true && value.is_approved_by_landlord === false"
                         class="status-box-row">
                        <div class="dot orange"></div>
                        {{ $t('digital.tabs.review.pending-approval') }}
                    </div>
                    <div
                        v-if="value.is_landlord_approval_requested === false && value.is_approved_by_landlord === false"
                        class="status-box-row">
                        <div class="dot gray"></div>
                        {{ $t('digital.tabs.review.not-yet-sent-for-approval') }}
                    </div>
                    <div v-if="value.is_approved_by_landlord === true" class="status-box-row">
                        <div class="dot green"></div>
                        {{ $t('digital.tabs.review.approval-confirmed') }}
                    </div>
                </div>
            </div>

            <div class="box preview-box">
                <p class="subject">{{$t('digital.tabs.review.contractsbeingsent')}}</p>
                <div class="content">
                    <div class="info">
                        <div class="icon">
                            <SvgIcon icon="small-contract"/>
                        </div>
                        <p>{{$t('digital.tabs.review.leasecontract')}}</p>
                    </div>
                    <a>
                        <button class="purple" @click="$emit('preview')" :disabled="state === 'saving'">
                            <span>{{$t('digital.tabs.review.preview')}}</span>
                        </button>
                    </a>
                </div>
            </div>

        </div>

        <div class="seperator"></div>

        <button class="purple" :disabled="readyForSigning === false" @click="showConfirmation = true">
            {{$t('digital.tabs.sendemail')}}
        </button>

    </div>
</template>

<script>
import SvgIcon from "../../../components/Svg";
import CustomContractSendConfirmation from "./CustomContractSendConfirmation";

export default {
    name: "CustomContractReviewAndSend",
    props: ['value', 'state'],
    components: {
        CustomContractSendConfirmation,
        SvgIcon
    },
    data: function () {
        return {
            showConfirmation: false
        }
    },
    computed: {
        readyForSigning: function () {

            let approved = false;

            if (this.value.is_created_by_broker === true) {

                if (this.value.requires_landlord_approval === false) {
                    approved = true;
                } else if (this.value.is_approved_by_landlord === true) {
                    approved = true;
                }
            } else {
                approved = true;
            }

            let hasPagesWithSignatures = _.findIndex(this.value.custom_contract_pages, {has_signatures: true}) !== -1;

            return _.isString(this.value.landlord_email)
                && _.isArray(this.value.tenants)
                && this.value.tenants.length > 0
                && approved
                && hasPagesWithSignatures
                && this.state !== 'saving';
        },
        readyForApproval: function () {
            return _.isString(this.value.landlord_email);
        }
    },
    methods: {
        sendFor(action) {
            this.$emit('sending');

            axios({
                method: 'POST',
                url: `${window.config.apiUrl}api/custom-contract/${this.value.id}/send`,
                cancelToken: window.AuthorizationCancelSource.token,
                data: {
                    for: action,
                }
            }).then(response => {
                Object.assign(this.value, response.data.data);
                this.$emit('input', this.value);
                this.$emit('send');
            }).catch((e) => {
                this.$emit('error', e)
            });
        },
        revoke() {
            this.$emit('revoke');
        }
    }
}
</script>

<style scoped>
.box-revoke {
    flex-grow: 1;
    justify-content: flex-end;
    display: flex;
}
</style>
